document.addEventListener("DOMContentLoaded", function() {
  // Redirección al hacer clic en el encabezado
  var headings = document.querySelectorAll('.previus-purchased .heading.h3');
  headings.forEach(function (heading) {
    heading.style.cursor = 'pointer';
    heading.addEventListener('mouseover', function () {
      this.style.color = '#cf1b2b';
    });
    heading.addEventListener('mouseout', function () {
      this.style.color = '#cf1b2b';
    });
    heading.addEventListener('click', function () {
      window.location.href = "/pages/all-recently-puchased";
    });
  });

  loadRecentlyPurchasedProducts();

  async function loadRecentlyPurchasedProducts() {
    var items = document.querySelectorAll('.recently-purchased-sku-item');
    if (!items || items.length === 0) {
      hideSpinner();
      return;
    }

    var container = document.querySelector('.previus-purchased-list .product-list');
    if (!container) {
      hideSpinner();
      return;
    }

    // 1. Recopilar SKUs de Liquid
    var skus = [];
    items.forEach(function(item) {
      var sku = item.getAttribute('data-sku');
      if (sku && sku.trim() !== '' && skus.indexOf(sku.trim()) === -1) {
        skus.push(sku.trim());
      }
    });

    if (skus.length === 0) {
      hideSpinner();
      return;
    }

    // URL Endpoint de tu AWS Lambda
    var ENDPOINT_URL = 'https://zrlqbqjs4rt3sne3a7tzrrx3my0asnpx.lambda-url.us-east-1.on.aws/';

    try {
      // 2. Consulta única a AWS Lambda
      var res = await fetch(ENDPOINT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ "skus": skus })
      });

      if (!res.ok) {
        hideSpinner();
        return;
      }

      var resData = await res.json();
      var products = resData.products || [];

      if (products.length === 0) {
        hideSpinner();
        return;
      }

      // 3. Cargar las tarjetas HTML de los productos devueltos por AWS Lambda en paralelo
      var cardsHtml = await Promise.all(products.map(async function(p) {
        if (!p.handle) return null;
        try {
          var prodRes = await fetch('/products/' + p.handle + '?view=product-item');
          if (prodRes.ok) {
            return await prodRes.text();
          }
        } catch (err) {}
        return null;
      }));

      // 4. Inyectar DENTRO de .flickity-slider si el carrusel ya fue creado por el tema
      var targetContainer = container.querySelector('.flickity-slider') || container;
      var countAdded = 0;

      cardsHtml.forEach(function(html) {
        if (html) {
          $(targetContainer).append(html);
          countAdded++;
        }
      });

      if (countAdded === 0) {
        hideSpinner();
        return;
      }

      // 5. Recargar Flickity Carousel y Sincronizar precios B2B
      setTimeout(function() {
        if (window.Flickity) {
          var flkty = Flickity.data(container);
          if (flkty) {
            flkty.reloadCells();
            flkty.resize();
          }
        }
        window.dispatchEvent(new Event('resize'));

        // Primera ejecución de showPrice al renderizar el DOM
        shoProductPrintPrv();
      }, 200);

      // Re-ejecutar showPrice tras 800ms para asegurar cálculo de precios B2B en clientes con retardos de red
      setTimeout(function() {
        shoProductPrintPrv();
      }, 800);

    } catch (e) {
      console.error('Error cargando productos desde AWS Lambda:', e);
    } finally {
      hideSpinner();
    }
  }

  function hideSpinner() {
    var spinner = document.getElementById('loading-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }
  }

  function shoProductPrintPrv() {
    var products = [];
    $('.previus-purchased-list .product-item').each(function() {
      var id = $(this).attr('data-id') || $(this).data('id') || $(this).data('usf-pid');
      var sku = $(this).attr('data-sku') || $(this).data('sku') || $(this).data('usfsku') || '';

      var priceElem = $(this).find('.product-item__price-list .price');
      var price = priceElem.attr('data-price') || priceElem.data('price') || priceElem.text() || '';

      if (price && typeof price === 'string') {
        price = price.replace('$', '').replace('CLP', '').replace(/\n/g, '').replace('Precio de venta', '').replace('+IVA', '').trim();
      }

      if (id) {
        products.push({ id: String(id), sku: String(sku), price: String(price) });
      }
    });

    if (products.length > 0) {
      if (typeof showPrice === 'function') {
        showPrice(products);
      } else if (typeof window.showPrice === 'function') {
        window.showPrice(products);
      }
    }
  }

  setTimeout(function() {
    $('.previus-purchased-list .product-list .product-item__action-button').click(async function() {
      if (typeof miniCardPrice === 'function') miniCardPrice();
      if (typeof miniClick === 'function') miniClick();
    });
  }, 1000);
});
